import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@follosoft/react-components";

export function useAcceptClauseService() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      contractId,
      clauseId,
    }: {
      contractId: number | string;
      clauseId: number | string;
    }) => {
      return axiosInstance().post(
        `/folloportal/contracts/${contractId}/clauses/${clauseId}/accept`
      );
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["available-clauses", Number(variables.contractId)],
      });
    },
  });
}
